// メモ表示可能ZOOM値
export const stickyNoteSearchableZoom = 12;

export const urlRegex = /(https?:\/\/[\w!?/+\-_~;.,*&@#$%()='[\]]+)/g;
